import environment from '@/utils/environment'

export default {
  computed: {
    environment () {
      return environment
    }
  }
}
